
if(jQuery(".pagination").length) {

    var fniv = jQuery(".pagination .prev").next("span").find("a").attr("href");

    if(fniv && fniv.indexOf("?page=1") >= 0) {

  let newval = fniv.replace('?page=1','');

      jQuery(".pagination .prev").next("span").find("a").attr("href", newval);

    }

    if(jQuery(".pagination .prev").length){

    if(jQuery(".pagination .prev a").attr("href").indexOf("?page=1") >= 0) {

          let newval = fniv.replace('?page=1','');

          jQuery(".pagination .prev a").attr("href", newval);

    }

    }

  }